import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CircleProgressBarComponent} from './circle-progress-bar.component';
import {SharedModule} from '../../shared/shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {IconsModule} from '../../icons/icons.module';

@NgModule({
  declarations: [
    CircleProgressBarComponent
  ],
  exports: [
    CircleProgressBarComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatProgressSpinnerModule,
    IconsModule,
  ]
})
export class CircleProgressBarModule {
}
